import React from "react";
import {
  Container,
  Description,
  Image,
  Title,
  Button,
} from "./SystemMaintain.style";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const SystemMaintain = () => {
  const { t } = useTranslation();
  const { maintain_message } = useSelector((state) => state.app);

  return (
    <Container>
      <Image />
      <Title>{t("error.systemMaintenanceTitle")}</Title>
      <Description>{maintain_message}</Description>
      <Button type="primary" onClick={() => window.location.reload()}>
        {t("error.retry")}
      </Button>
    </Container>
  );
};

export default SystemMaintain;
